import type { McpServer } from '../../components/McpServerEditor';

/** 配置中心左侧维度 Tab 的顺序标签。 */
export const DIMENSION_LABELS = ['人设', '技能', '工作流', '记忆', '工具', 'MCP 工具', '知识', 'LLM', '数字人', 'API Token', '定时任务', '进化', '沉淀'];

/** MCP 工具市场预置服务器：添加预设时经 handleUpdateMcpServers 写入 /agents/{id}/mcp-servers。 */
export const MCP_PRESETS: McpServer[] = [
  {
    id: 'mcp-filesystem',
    name: '文件系统 MCP',
    description: '允许 Agent 读取和写入本地文件系统。',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-filesystem', '/workspace'],
    env: {},
  },
  {
    id: 'mcp-fetch',
    name: 'Fetch MCP',
    description: '让 Agent 通过 HTTP 获取网页内容。',
    command: 'uvx',
    args: ['mcp-server-fetch'],
    env: {},
  },
  {
    id: 'mcp-github',
    name: 'GitHub MCP',
    description: '让 Agent 通过 GitHub API 查询仓库、Issue、PR 等。',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-github'],
    env: { GITHUB_PERSONAL_ACCESS_TOKEN: '<your-token>' },
  },
  {
    id: 'mcp-postgres',
    name: 'PostgreSQL MCP',
    description: '让 Agent 对 PostgreSQL 执行只读查询。',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-postgres', 'postgresql://user:pass@localhost/db'],
    env: {},
  },
];
